import { render, staticRenderFns } from "./WaterHistory.vue?vue&type=template&id=fa956736&scoped=true&"
import script from "./WaterHistory.vue?vue&type=script&lang=ts&"
export * from "./WaterHistory.vue?vue&type=script&lang=ts&"
import style0 from "./WaterHistory.vue?vue&type=style&index=0&id=fa956736&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa956736",
  null
  
)

export default component.exports